var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 183,
    viewBox: "0 0 189 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.594 28.2656H18.8438C13.8476 28.2706 9.05752 30.2575 5.52472 33.7903C1.99191 37.3231 0.00498866 42.1132 0 47.1094V163.312C0.00498866 168.309 1.99191 173.099 5.52472 176.632C9.05752 180.164 13.8476 182.151 18.8438 182.156H169.594C174.59 182.151 179.38 180.164 182.913 176.632C186.446 173.099 188.433 168.309 188.438 163.312V47.1094C188.433 42.1132 186.446 37.3231 182.913 33.7903C179.38 30.2575 174.59 28.2706 169.594 28.2656ZM182.156 163.312C182.156 166.644 180.833 169.84 178.477 172.196C176.121 174.551 172.926 175.875 169.594 175.875H18.8438C15.512 175.875 12.3166 174.551 9.96072 172.196C7.60479 169.84 6.28125 166.644 6.28125 163.312V53.0938H182.156V163.312Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.609 6.28125C147.609 4.61536 146.948 3.0177 145.77 1.83974C144.592 0.661772 142.994 0 141.328 0C139.662 0 138.065 0.661772 136.887 1.83974C135.709 3.0177 135.047 4.61536 135.047 6.28125V21.9844H147.609V6.28125Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3906 6.28125C53.3906 4.61536 52.7289 3.0177 51.5509 1.83974C50.3729 0.661772 48.7753 0 47.1094 0C45.4435 0 43.8458 0.661772 42.6679 1.83974C41.4899 3.0177 40.8281 4.61536 40.8281 6.28125V21.9844H53.3906V6.28125Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.b54775f8e24cf1caa5c0d65ea846c82c.svg";
export { ForwardRef as ReactComponent };